import { createAction, props } from '@ngrx/store';
export const setCustomTexts = createAction('[Custom PDF Report Modal] Set Custom Texts', props());
